<template>
  <FormItemWrapper class="summer">
    <FormItemLabel slot="label">
      {{ $t('billTableSideLabelReactiveHT') }}
    </FormItemLabel>
    <Tooltip
      v-if="$t('billTableSideLabelReactiveHT')"
      slot="tooltip"
      :content="$t('billTableSideLabelReactiveHT')"
    />
    <el-input
      v-model="reactiveHT"
      type="number"
      class="summer"
      placeholder=""
    >
      <template slot="append">kVArh</template>
    </el-input>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { onKeydownAllowNumbersOnly } from '@/utils/validation';
import debounce from 'lodash/debounce';
import { Input } from 'element-ui';
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Input);

export default {
  name: 'CalculationReactiveHT',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  computed: {
    reactiveHT: {
      get() {
        return this.$store.state.reactive.reactiveCalculationData.reactiveHT;
      },
      set(value) {
        this.update(value);
      },
    },
  },
  methods: {
    update: debounce(function update(value) {
      this.$store.commit('reactive/SET_REACTIVE_HT', Number(value));
    }, 5),
    onKeydownAllowNumbersOnly,
  },
};
</script>
